export function Banner({ title }: { title: string }) {
    return <div style={{ backgroundColor: 'lightblue', padding: '10px' }}>{title}</div>
}

export default class BannerApp {
    constructor({ id, title }: { id: string; title: string }) {
        const el = document.getElementById(id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<Banner title={title} />)
    }
}
